import { ReduxHelper } from "helpers";
import {
  IGetPrepareDetailRequest,
  IPaginateApiResponse,
  IPaginationRequest,
  IPrepare,
  IPrepareDetail,
  IUpdatePrepareDocumentRequest,
} from "model";

export const prefix = "PREPARE";

export const getAllPrepareDocuments = ReduxHelper.generateActions<
  IPaginationRequest,
  IPaginateApiResponse<IPrepare[]>
>(prefix, "GET_ALL_PREPARE_DOCUMENTS");
export const getPrepareDocumentDetail = ReduxHelper.generateActions<
  IGetPrepareDetailRequest,
  IPaginateApiResponse<IPrepareDetail[]>
>(prefix, "GET_PREPARE_DOCUMENT_DETAIL");
export const updatePrepareDocument = ReduxHelper.generateActions<
  IUpdatePrepareDocumentRequest,
  IPrepare
>(prefix, "UPDATE_PREPARE_DOCUMENT");
